import { apiFetch, apiPost, apiPut, apiDelete } from '@/lib/api-client';

export async function getInsights() {
  try {
    return await apiFetch<any[]>('/api/insights');
  } catch {
    return [];
  }
}

export async function getFeaturedInsight() {
  try {
    return await apiFetch<any>('/api/insights/featured');
  } catch {
    return null;
  }
}

export async function getInsightById(id: string) {
  try {
    return await apiFetch<any>(`/api/insights/${id}`);
  } catch {
    return null;
  }
}

export async function getInsightBySlug(slug: string) {
  try {
    return await apiFetch<any>(`/api/public/insights/slug/${encodeURIComponent(slug)}`);
  } catch {
    return null;
  }
}

export async function getInsightsList(industry?: string) {
  try {
    const q = industry ? `?industry=${encodeURIComponent(industry)}` : '';
    return await apiFetch<{ articles: any[]; footprint: any }>(`/api/public/insights/list${q}`);
  } catch {
    return { articles: [], footprint: null };
  }
}

export async function createInsight(data: any) {
  return apiPost('/api/insights', data);
}

export async function updateInsight(id: string, data: any) {
  return apiPut(`/api/insights/${id}`, data);
}

export async function deleteInsight(id: string) {
  return apiDelete(`/api/insights/${id}`);
}
